import { fromJS } from 'immutable'
import {
  DIVISION_DEACTIVATE_REQUEST,
  DIVISION_DEACTIVATE_SUCCESS,
  DIVISION_DEACTIVATE_FAILURE,
  DIVISION_DEACTIVATE_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case DIVISION_DEACTIVATE_REQUEST:
      return state
        .set('isFetching', true)
    case DIVISION_DEACTIVATE_SUCCESS:
      return state
        .set('divisionDeactivate', fromJS(action.payload.deletedDivision))
        .set('status', 200)
        .set('message', 'Deleted Successfully.')
        .set('isFetching', false)
    case DIVISION_DEACTIVATE_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('divisionDeactivate', fromJS(action.payload.message))
        .set('status', fromJS(action.payload.response.statusCode))
        .set('message', fromJS(action.payload.response.message))
        .set('isFetching', false)
    case DIVISION_DEACTIVATE_RESET:
      return state
        .delete('divisionDeactivate')
        .delete('status')
        .delete('message')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/division/division-deactivate-reducer.js